import React from 'react';
import { motion } from 'framer-motion';

const teamData = [
    {
        id: 1,
        name: "Daniel Brooks",
        role: "CHIEF OPERATING OFFICER",
        desc: "Leads operational strategy and execution across the organization.",
        image: "/assets/customer/item2.png",
        bgColor: "bg-[#E5E1E8]"
    },
    {
        id: 2,
        name: "Natalie Cruz",
        role: "CHIEF FINANCIAL OFFICER",
        desc: "Oversees financial planning, risk management, and fiscal compliance.",
        image: "/assets/customer/item3.png",
        bgColor: "bg-[#DFF1F1]"
    },
    {
        id: 3,
        name: "Lauren Mitchell",
        role: "CHIEF MARKETING OFFICER",
        desc: "Drives brand strategy, market positioning, and global communications.",
        image: "/assets/customer/item4.png",
        bgColor: "bg-[#FBE3D7]"
    },
    {
        id: 4,
        name: "Daniel Brooks",
        role: "CHIEF OPERATING OFFICER",
        desc: "Leads operational strategy and execution across the organization.",
        image: "/assets/customer/item2.png",
        bgColor: "bg-[#E5E1E8]"
    },
    {
        id: 5,
        name: "Natalie Cruz",
        role: "CHIEF FINANCIAL OFFICER",
        desc: "Oversees financial planning, risk management, and fiscal compliance.",
        image: "/assets/customer/item3.png",
        bgColor: "bg-[#DFF1F1]"
    },
    {
        id: 6,
        name: "Lauren Mitchell",
        role: "CHIEF MARKETING OFFICER",
        desc: "Drives brand strategy, market positioning, and global communications.",
        image: "/assets/customer/item4.png",
        bgColor: "bg-[#FBE3D7]"
    }
];

const LeadershipTeam = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.1 }
        }
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    return (
        <section className="w-full bg-[#FFFFFF] pb-16 lg:pb-24 overflow-hidden select-none text-left relative z-50">
            <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-8 w-full items-stretch"
                >
                    {teamData.map((member) => (
                        <motion.div
                            key={member.id}
                            variants={cardVariants}
                            whileHover={{ y: -4 }}
                            transition={{ duration: 0.3 }}
                            className="w-full bg-white border border-gray-200 rounded-none flex flex-col overflow-hidden group cursor-pointer shadow-[0_4px_20px_rgba(0,0,0,0.01)]"
                        >

                            <div className={`w-full lg:min-h-[421px] min-h-[300px] aspect-[4/5] sm:aspect-auto relative overflow-hidden shrink-0 ${member.bgColor}`}>
                                <div className="absolute top-4 left-4 bg-white px-2.5 py-1.5 rounded-[2px] shadow-2xs z-20">
                                    <span className="text-[#01386A] font-sora font-[600] text-[12px] lg:text-[14px] uppercase tracking-wider">
                                        {member.role}
                                    </span>
                                </div>

                                <img
                                    src={member.image}
                                    alt={member.name}
                                    className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[82%] h-auto object-contain z-10 transition-transform duration-700 ease-out group-hover:scale-104"
                                />
                            </div>

                            <div className="p-6 sm:p-8 flex flex-col flex-1 items-start justify-start bg-white">
                                <h3 className="text-[#01386A] font-[600] font-sora text-[16px] lg:text-[20px] tracking-tight leading-none mb-3">
                                    {member.name}
                                </h3>
                                <p className="text-[#49577A] text-[14px] lg:text-[16px] leading-relaxed font-[500] font-graphik line-clamp-3">
                                    {member.desc}
                                </p>
                            </div>

                        </motion.div>
                    ))}
                </motion.div>

            </div>
        </section>
    );
};

export default LeadershipTeam;